
export default function MediaPreviewDialog({

    open,

    media,

    url,

    onClose

}){

    if(!open || !media){

        return null;

    }

    function renderPreview(){

        if(media.isImage){

            return(

                <img

                    src={url}

                    alt={media.original_name}

                    className="preview-image"

                />

            );

        }

        if(media.isVideo){

            return(

                <video

                    controls

                    className="preview-video"

                >

                    <source

                        src={url}

                        type={media.mime_type}

                    />

                </video>

            );

        }

        if(media.isAudio){

            return(

                <audio

                    controls

                    className="preview-audio"

                >

                    <source

                        src={url}

                        type={media.mime_type}

                    />

                </audio>

            );

        }

        if(

            media.mime_type.includes("pdf")

        ){

            return(

                <iframe

                    title={media.original_name}

                    src={url}

                    className="preview-pdf"

                />

            );

        }

        return(

            <div className="preview-empty">

                <div className="preview-file-icon">

                    📁

                </div>

                <div>

                    Preview is not available.

                </div>

            </div>

        );

    }

    return(

        <div className="preview-overlay">

            <div className="preview-dialog">

                <div className="preview-header">

                    <div>

                        <h2>

                            {media.original_name}

                        </h2>

                        <p>

                            {media.mime_type}

                        </p>

                    </div>

                    <button

                        className="preview-close"

                        onClick={onClose}

                    >

                        ✕

                    </button>

                </div>

                <div className="preview-body">

                    {renderPreview()}

                </div>

                <div className="preview-footer">

                    <a

                        href={url}

                        target="_blank"

                        rel="noreferrer"

                        download={media.original_name}

                        className="btn btn-primary"

                    >

                        Download

                    </a>

                    <button

                        className="btn"

                        onClick={onClose}

                    >

                        Close

                    </button>

                </div>

            </div>
   <style>{`.preview-overlay{

    position:fixed;
   
    inset:0;

    background:rgba(15,23,42,.65);

    display:flex;

    justify-content:center;

    align-items:center;

    padding:30px;

    z-index:9999;

}

.preview-dialog{
   position:relative;top:0px;
    width:min(1200px,95vw);

    height:min(90vh,900px);

    display:flex;

    flex-direction:column;

    background:#FFF;

    border-radius:20px;

    overflow:hidden;

    box-shadow:0 30px 80px rgba(0,0,0,.25);

}

.preview-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:24px;

    border-bottom:1px solid #ECEFF4;

}

.preview-header h2{

    margin:0;

    font-size:22px;

}

.preview-header p{

    margin-top:6px;

    color:#64748B;

}

.preview-close{

    width:42px;

    height:42px;

    border:none;

    border-radius:10px;

    background:#F3F4F6;

    cursor:pointer;

}

.preview-body{

    flex:1;

    overflow:auto;

    display:flex;

    justify-content:center;

    align-items:center;

    background:#F8FAFC;

    padding:24px;

}

.preview-image{

    max-width:100%;

    max-height:100%;

    object-fit:contain;

}

.preview-video{

    width:100%;

    max-height:100%;

}

.preview-audio{

    width:100%;

}

.preview-pdf{

    width:100%;

    height:100%;

    border:none;

    background:#FFF;

}

.preview-empty{

    display:flex;

    flex-direction:column;

    align-items:center;

    gap:16px;

    color:#64748B;

}

.preview-file-icon{

    font-size:64px;

}

.preview-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

    padding:20px 24px;

    border-top:1px solid #ECEFF4;

}`}</style>
        </div>

    );

}